var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "mb-0",
      attrs: { "body-class": "p-0" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "b-row",
                { staticClass: "py-2 align-items-center" },
                [
                  _c("b-col", { attrs: { cols: "1", lg: "2", md: "4" } }, [
                    _c("h3", { staticClass: "section-separator-title" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("filogix.yourDeals")) +
                          "\n        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "1", lg: "3", md: "4" } }, [
                    _c("h3", { staticClass: "section-separator-title" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.doorr.dateCreated")) +
                          "\n        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "1", lg: "3", md: "4" } }),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "1", lg: "3" } }, [
                    _c("h3", { staticClass: "section-separator-title" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("filogix.expertSync.errorDetails")) +
                          "\n        "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("deal-list", {
        attrs: {
          "filogix-submissions": _vm.filogixSubmissions,
          lenders: _vm.lenders,
          "client-username": _vm.clientUsername,
          "application-id": _vm.applicationId,
          "agent-username": _vm.agentUsername,
        },
        on: { refresh: _vm.refreshFilogixSubmissions },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }